"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMBER_COLUMNS_POSITION = exports.MEMBERS_FILE_STRUCTURE = void 0;
const validated_data_1 = require("./validated-data");
exports.MEMBERS_FILE_STRUCTURE = [
    {
        columnName: 'Apellido Paterno',
        cell: 'A1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Apellido Materno',
        cell: 'B1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Nombres',
        cell: 'C1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'RFC',
        cell: 'D1',
        type: validated_data_1.ColumnType.RFC,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Correo Electronico',
        cell: 'E1',
        type: validated_data_1.ColumnType.EMAIL,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Telefono',
        cell: 'F1',
        type: validated_data_1.ColumnType.PHONE,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Producto',
        cell: 'G1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Pago',
        cell: 'H1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: true,
        isRequiredInFile: true,
    },
    {
        columnName: 'Estado del Registro',
        cell: 'I1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: true,
        isRequiredInFile: false,
    },
    {
        columnName: 'ID',
        cell: 'J1',
        type: validated_data_1.ColumnType.TEXT,
        isVisible: false,
        isRequiredInFile: false,
    },
];
var MEMBER_COLUMNS_POSITION;
(function (MEMBER_COLUMNS_POSITION) {
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["LAST_NAME"] = 0] = "LAST_NAME";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["LAST_NAME_MOTHER"] = 1] = "LAST_NAME_MOTHER";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["FIRST_NAME"] = 2] = "FIRST_NAME";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["RFC"] = 3] = "RFC";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["EMAIL"] = 4] = "EMAIL";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["PHONE"] = 5] = "PHONE";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["PRODUCT"] = 6] = "PRODUCT";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["PAYMENT"] = 7] = "PAYMENT";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["STATUS"] = 8] = "STATUS";
    MEMBER_COLUMNS_POSITION[MEMBER_COLUMNS_POSITION["ID"] = 9] = "ID";
})(MEMBER_COLUMNS_POSITION || (exports.MEMBER_COLUMNS_POSITION = MEMBER_COLUMNS_POSITION = {}));
//# sourceMappingURL=members-file-structure.js.map